<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-card :bordered="false">
        <a-row>
          <a-col :span="8">
            <div style="padding: 2px">
              <div class="one" style="float: left;">
                <span :class="isAddressOrderSelect === '1'?'isActive': ''" @click="handelAddressOrderClick('1')" style="font-size: 12px">昨日</span>
                <span :class="isAddressOrderSelect === '7'?'isActive': ''" @click="handelAddressOrderClick('7')" style="font-size: 12px">近7日</span>
                <span :class="isAddressOrderSelect === '30'?'isActive': ''" @click="handelAddressOrderClick('30')" style="font-size: 12px">近30日</span>
                <span :class="isAddressOrderSelect === '90'?'isActive': ''" @click="handelAddressOrderClick('90')" style="font-size: 12px">近三月</span>
                <span :class="isAddressOrderSelect === '365'?'isActive': ''" @click="handelAddressOrderClick('365')" style="margin-right:10px; font-size: 12px">一年</span>
              </div>
              <a-range-picker v-model="addressDateRange" style="width: 300px" valueFormat="YYYY-MM-DD" @change="addressOrderDateChange" size="small"/>
            </div>
            <div id="addressOrderChart" style="width: 600px;height: 400px"></div>
          </a-col>
          <a-col :span="16">
            <div id="merchantFocusChart" style="height: 600px"></div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="18">
            <div style="padding: 5px">
              <div class="one" style="float: left;">
                <span :class="isOrderAmountSelect === '1'?'isActive': ''" @click="handelOrderAmountClick('1')">昨日</span>
                <span :class="isOrderAmountSelect === '7'?'isActive': ''" @click="handelOrderAmountClick('7')">近7日</span>
                <span :class="isOrderAmountSelect === '30'?'isActive': ''" @click="handelOrderAmountClick('30')">近30日</span>
                <span :class="isOrderAmountSelect === '90'?'isActive': ''" @click="handelOrderAmountClick('90')" >近三月</span>
                <span :class="isOrderAmountSelect === '365'?'isActive': ''" @click="handelOrderAmountClick('365')" style="margin-right:10px;">一年</span>
              </div>
              <a-range-picker v-model="amountDateRange" valueFormat="YYYY-MM-DD" @change="orderAmountDateChange" size="default"/>
            </div>
            <div id="orderAmountChart" style="height: 600px"></div>
          </a-col>
        </a-row>
      </a-card>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import * as echarts from 'echarts'
import {
  merchantAmount,
  merchantFocus,
  merchantAddress
} from "@/api/statistics/merchant";
import moment from 'moment';
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import {tableMixin} from '@/store/table-mixin'


export default {
  name: 'MerchantStatistics',
  components: {
    CustomDictTag
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      starList: [],
      clubList: [],
      categoryList: [{id: "0", categoryName: ''}],
      cateOptions: [],
      brandList: [],
      labelList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      activeKey: 1,
      addressDateRange:[],
      addressOrderParam: {
        chartType: '1',
        startTime: undefined,
        endTime: undefined,
      },
      amountDateRange:[],
      orderAmountParam: {
        chartType: '1',
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
        sortField: 'payAmount',
        sortOrder: 'desc'
      },
      activeParam: {
        chartType: '1',
        endTime: undefined,
      },
      /*销售数据选择*/
      isAddressOrderSelect: undefined,
      isOrderAmountSelect: undefined,

    }
  },
  filters: {},
  created() {
  },
  mounted() {
    this.handelOrderAmountClick('30')
    this.handelAddressOrderClick('30')
    this.drawMerchantFocusChart()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },


    /** 搜索按钮操作 */
    /** 重置按钮操作 */

    /** 导出按钮操作 */
    subDay(num) {
      return moment().add(-num, 'days');
    },
    handelAddressOrderClick(val) {
      this.isAddressOrderSelect = val;
      this.addressOrderParam.chartType = val;
      let startDate = this.subDay(val).format('YYYY-MM-DD');
      let endDate = moment().format('YYYY-MM-DD');
      this.addressOrderParam.startTime = startDate + " 00:00:00";
      this.addressOrderParam.endTime = endDate + " 23:59:59";
      this.addressDateRange= []
      this.addressDateRange.push(startDate)
      this.addressDateRange.push(endDate)
      this.drawAddressOrderChart();
    },
    addressOrderDateChange(val) {
      this.addressOrderParam.startTime = val[0] + ' 00:00:00';
      this.addressOrderParam.endTime = val[1] + ' 23:59:59';
      this.drawAddressOrderChart();
    },
    handelOrderAmountClick(val) {
      this.isOrderAmountSelect = val;
      this.orderAmountParam.chartType = '1';
      let startDate = this.subDay(val).format('YYYY-MM-DD');
      let endDate = moment().format('YYYY-MM-DD');
      this.orderAmountParam.startTime = startDate + " 00:00:00";
      this.orderAmountParam.endTime = endDate + " 23:59:59";
      this.amountDateRange= []
      this.amountDateRange.push(startDate)
      this.amountDateRange.push(endDate)
      this.drawOrderAmountChart();
    },
    orderAmountDateChange(val) {
      this.orderAmountParam.startTime = val[0] + ' 00:00:00';
      this.orderAmountParam.endTime = val[1] + ' 23:59:59';
      this.drawOrderAmountChart();
    },


    drawAddressOrderChart() {
      // // 添加
      var chartDom = document.getElementById("addressOrderChart");
      var myChart = echarts.init(chartDom);
      var option;
      merchantAddress(this.addressOrderParam).then((res) => {
        if (res.code === "20001") {
          option = {
            title: {
              text: '商家区域分布',
              //subtext: 'Fake Data',
              left: 'center'
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {
              orient: 'vertical',
              left: 'left'
            },
            series: [
              {
                name: '地区',
                type: 'pie',
                radius: '50%',
                data: res.data,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ],
            graphic: [
              {
                type: 'text',
                right: 100,
                top: 20,
                style: {
                  text: 'Back',
                  fontSize: 18,
                  fill: 'grey'
                },
                onclick: function () {
                  option && myChart.setOption(option);
                }
              }
            ]
          };
          option && myChart.setOption(option);
          myChart.on('click', function (params) {
            console.log('点击', params)
            if (params.seriesType === 'pie') {
              // 基于点击的数据进行下钻操作
              // 例如，更新数据或者调用另一个echarts实例来显示下钻内容
              var drilldownOption = {
                series: [
                  {
                    name: '详细数据',
                    type: 'pie',
                    radius: '55%',
                    data: params.data.children
                  }
                ]
              };
              myChart.setOption(drilldownOption);
            }
          });
        }
      });
    },

    drawOrderAmountChart() {
      // // 添加
      var chartDom = document.getElementById("orderAmountChart");
      var myChart = echarts.init(chartDom);
      var option;
      merchantAmount(this.orderAmountParam).then((res) => {
        if (res.code === "20001") {
          let records = res.data.records;
          let name = records.map(e => e.merchantName);
          let payAmount = records.map(e => e.payAmount);
          option = {
            title: {
              text: '商家销售金额排行榜',
              //subtext: 'Fake Data',
              left: 'center'
            },
            xAxis: {
              type: 'category',
              data: name
            },
            yAxis: {
              type: 'value',
              axisLabel: { // y轴的标签配置
                show: true, // 显示标签
                formatter: '{value}' // 格式化标签内容，这里直接显示数值
              }
            },
            series: [
              {
                name: '销售金额',
                data: payAmount,
                type: 'bar',
                itemStyle: {
                  emphasis: {
                    label: {
                      show: true,
                      formatter: function (params) {
                        return params.value;
                      },
                      //一下为label的一些配置项，设置外边框，背景颜色，字体颜色等
                      backgroundColor: 'rgba(61,126,255,0.09)',
                      borderColor: '#3d7eff',
                      borderWidth: 0.5,
                      borderRadius: 2,
                      padding: 6,
                      position: 'top',
                      textStyle: {
                        color: '#3D7EFF',
                        fontSize: 14,
                        marginLeft: 0,
                        lineHeight: 20
                      }
                    }
                  }
                }
              }
            ]
          };
          option && myChart.setOption(option);
        }
      });
    },

    drawMerchantFocusChart() {
      // // 添加
      var chartDom = document.getElementById("merchantFocusChart");
      var myChart = echarts.init(chartDom);
      var option;
      merchantFocus({}).then((res) => {
        if (res.code === "20001") {
          let records = res.data.records;
          let name = records.map(e => e.merchantName);
          let payAmount = records.map(e => e.focusNum);
          option = {
            title: {
              text: '商家关注数排行榜',
              //subtext: 'Fake Data',
              left: 'center'
            },
            xAxis: {
              type: 'category',
              data: name
            },
            yAxis: {
              type: 'value',
              axisLabel: { // y轴的标签配置
                show: true, // 显示标签
                formatter: '{value}' // 格式化标签内容，这里直接显示数值
              }
            },
            series: [
              {
                name: '关注数',
                data: payAmount,
                type: 'bar',
                itemStyle: {
                  emphasis: {
                    label: {
                      show: true,
                      formatter: function (params) {
                        return params.value;
                      },
                      //一下为label的一些配置项，设置外边框，背景颜色，字体颜色等
                      backgroundColor: 'rgba(61,126,255,0.09)',
                      borderColor: '#3d7eff',
                      borderWidth: 0.5,
                      borderRadius: 2,
                      padding: 6,
                      position: 'top',
                      textStyle: {
                        color: '#3D7EFF',
                        fontSize: 14,
                        marginLeft: 0,
                        lineHeight: 20
                      }
                    }
                  }
                }
              }
            ]
          };
          option && myChart.setOption(option);
        }
      });
    },

  }
}
</script>
<style>
.sta-table .ant-table-thead > tr > th {
  background-color: #bae7ff !important;
}
</style>
<style lang="less" scoped>
.one {
  margin-left: 1px;
  margin-right: 1px;

  span {
    display: inline-block;
    line-height: 23px;
    width: 60px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #999999;
    // color: #1890ff;
  }

  span:nth-child(1) {
    border-radius: 6px 0 0 6px;
    border-right: none;

  }

  span:nth-child(2) {
    border-radius: 0;
    border-right: none;

  }

  span:nth-child(3) {
    border-radius: 0;
    border-right: none;

  }

  span:nth-child(4) {
    border-radius: 0 6px 6px 0;
    position: relative;
  }

  span:nth-child(4) .el-date-editor {
    position: absolute; //绝对定位
    top: 0;
    left: 0;
    opacity: 0; //设置完全透明
  }
}

.isActive {
  background: #1890ff;
  color: #ffffff !important;
  border: 1px solid #1890ff !important;
}

.ant-card-body {
  padding: 5px;
}

</style>
